import { Radio } from '@mui/material';

const ModeOfSignRadioButton = ({ option, selected, onChange}) => {
    
    return (
        <Radio
            size='small'
            value={option}
            checked={true}
            onChange={() => onChange(option)}
            sx={{ padding: 0 }}
        />
    );
};

export default ModeOfSignRadioButton;
